import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import ProjectsPage from './components/ProjectsPage';
import AddProjectPage from './components/AddProjectPage';
import EditProjectPage from './components/EditProjectPage';
import Detail from './components/Detail';
import Dashboard from './components/Dashboard';
import ProfilePage from './components/ProfilePage';
import PrivateRoute from './components/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const App: React.FC = () => {
    useEffect(() => {
        console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    }, []);

    return (
        <Router>
            <ToastContainer />
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<PrivateRoute />}>
                    <Route path="/" element={<Dashboard />}>
                        <Route index element={<ProjectsPage />} />
                        <Route path="add" element={<AddProjectPage />} />
                        <Route path="edit/:id" element={<EditProjectPage />} />
                        <Route path="detail/:id" element={<Detail />} />
                        <Route path="profile" element={<ProfilePage />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    );
};

export default App;
